module.exports = __webpack_public_path__ + "static/media/logoNAAT_CouleurJAUNE_fit800.4dd73af9.png";